import { State } from '../state';

export const UserSelectors = {
    email: (state: State): string =>
        (state.User && state.User.loggedInUser && state.User.loggedInUser.user && state.User.loggedInUser.user.email) ||
        '',

    name: (state: State): string =>
        state.User && state.User.loggedInUser.user
            ? `${state.User.loggedInUser.user.fName} ${state.User.loggedInUser.user.lName}`
            : '',

    initials: (state: State): string =>
        state.User &&
        state.User.loggedInUser.user &&
        state.User.loggedInUser.user.fName &&
        state.User.loggedInUser.user.lName
            ? `${state.User.loggedInUser.user.fName.charAt(0)}${state.User.loggedInUser.user.lName.charAt(0)}`
            : '',

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    changePassword: (state: State) => state.User.changePassword,

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    user: (state: State) => state.User,

    session: (state: State): boolean =>
        state.User &&
        state.User.loggedInUser &&
        state.User.loggedInUser.session &&
        state.User.loggedInUser.session.sessionEnabled,
};
